import { B as g, j as r, T as P } from "./Spinner-dTAYYnIx.js";
import { useCallback as W, useState as D } from "react";
import { u as A } from "./useTransitionState-9D4Z4_FK.js";
import { u as E, a as L } from "./useElementRefById-afvP7SGi.js";
import { u as S } from "./useAddBodyClass-J7-kOyEU.js";
import I from "focus-trap-react";
import { css as t, styled as n } from "styled-components";
import { s as m, j as $, c as f, a as o, B as i } from "./style-8UHgYe1v.js";
import { z as v, f as u, p as O, P as k, b as Y } from "./index-QRkynDgW.js";
import { createPortal as q } from "react-dom";
import { C as G } from "./icon-close-SnhI1pSy.js";
import { F as H } from "./icon-filters-vC2aY28V.js";
import { P as K } from "./PreventBodyOverflow-4Tam5bLu.js";
const R = "376px", U = "585px", J = "690px", b = t`
  inset: auto 0 0;
  transform: translateY(100%);
`, M = n.div`
  ${m("100%")};

  position: fixed;
  inset: 0;
  z-index: ${v.fixed};
`, N = n.div`
  ${$("opacity")};

  position: fixed;
  inset: 0;
  opacity: ${({ $isOpen: s }) => s ? 1 : 0};
  background: ${f.greyAlpha40};
  pointer-events: auto;
`, Q = n.div`
  ${u};
  ${$("transform")};
  ${m("100%")};

  position: fixed;
  z-index: ${v.drawerOverlay};

  ${({ $position: s, $forceEmergeFromBottomOnMobile: a }) => {
  if (s === "left")
    return a ? t`
          ${b}
          ${o(
      i.md,
      t`
              inset: 0 auto 0 0;
              transform: translateX(-100%);
            `
    )}
        ` : t`
        inset: 0 auto 0 0;
        transform: translateX(-100%);
      `;
  if (s === "right")
    return a ? t`
          ${b}
          ${o(
      i.md,
      t`
              inset: 0 0 0 auto;
              transform: translateX(100%);
            `
    )}
        ` : t`
        inset: 0 0 0 auto;
        transform: translateX(100%);
      `;
}}

  ${({ $isOpen: s, $forceEmergeFromBottomOnMobile: a }) => {
  if (s) {
    if (a)
      return t`
          transform: translateY(0);
          ${o(
        i.md,
        t`
              transform: translateX(0);
            `
      )}
        `;
    if (!a)
      return t`
          transform: translateX(0);
        `;
  }
}}

  ${o(
  i.md,
  t`
      width: unset;
    `
)}
`, V = n.div.attrs({
  $display: "flex",
  $flexDirection: "column"
})`
  ${u};
  ${$("transform")};
  ${m("100%")};

  background: ${f.white};
  overflow-y: auto;

  ${o(
  i.md,
  t`
      width: ${R};
    `
)}

  ${o(
  i.xl,
  t`
      width: ${U};
    `
)}

  ${o(
  i.xxl,
  t`
      width: ${J};
    `
)}
`, Z = n.div.attrs({
  $display: "flex",
  $justifyContent: "flex-end",
  $px: { xs: "spacer3", sm: "spacer4" },
  $py: { xs: "spacer3", sm: "spacer4" }
})`
  ${u};
  ${O};
  /* using margin to center header content */
  margin-left: 20px;
`, _ = n(k).attrs({
  $px: { xs: "spacer3", sm: "spacer4" },
  $py: { xs: "spacer3", sm: "spacer4" }
})`
  border-top: 1px solid ${f.grey};
  border-bottom: 1px solid ${f.grey};
  overflow-y: auto;
`, rr = n(g)`
  position: relative;

  &::after {
    ${m(44)};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    content: '';
  }
`, tr = ({
  headerContent: s,
  children: a,
  footerContent: l,
  isOpen: e = !1,
  position: c = "left",
  theme: p = "light",
  forceEmergeFromBottomOnMobile: B = !1,
  onClose: d,
  drawerRootId: y,
  t: F
}) => {
  const h = E(y), [z, x, T] = A(e, ["opacity"]);
  if (L(
    W(
      (w) => {
        w.key === "Escape" && e && typeof d == "function" && d(w);
      },
      [d, e]
    )
  ), S(e, "modal-open"), !y || !h || !z && !x)
    return null;
  const j = "drawer-section", { drawerAriaLabel: X, drawerCloseAriaLabel: C } = F;
  return q(
    /* @__PURE__ */ r.jsxs(P, { theme: p, children: [
      /* @__PURE__ */ r.jsx(K, { prevent: e }),
      /* @__PURE__ */ r.jsx(
        I,
        {
          active: !0,
          focusTrapOptions: {
            fallbackFocus: `#${j}`
          },
          children: /* @__PURE__ */ r.jsxs(M, { children: [
            /* @__PURE__ */ r.jsx(
              N,
              {
                onTransitionEnd: T,
                $isOpen: x,
                onClick: d,
                "data-qa": "backdrop"
              }
            ),
            /* @__PURE__ */ r.jsx(
              Q,
              {
                id: `drawer-${c}`,
                $position: c,
                $isOpen: x,
                $forceEmergeFromBottomOnMobile: B,
                children: /* @__PURE__ */ r.jsxs(V, { role: "dialog", "aria-label": X, id: j, children: [
                  /* @__PURE__ */ r.jsxs(Z, { children: [
                    !!s && /* @__PURE__ */ r.jsx(Y, { $flexGrow: "1", children: s }),
                    /* @__PURE__ */ r.jsx(
                      rr,
                      {
                        variant: "no-style",
                        icon: { icon: G, size: 20 },
                        "aria-label": C,
                        onClick: d
                      }
                    )
                  ] }),
                  !!a && /* @__PURE__ */ r.jsx(_, { children: a }),
                  !!l && /* @__PURE__ */ r.jsx(k, { $px: { xs: "spacer3", sm: "spacer4" }, $py: { xs: "spacer3", sm: "spacer4" }, children: l })
                ] })
              }
            )
          ] })
        }
      )
    ] }),
    h
  );
}, $r = ({
  isInitiallyOpen: s = !1,
  buttonLabel: a,
  drawerProps: l,
  children: e
}) => {
  const [c, p] = D(s);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(g, { variant: "icon", icon: { icon: H, size: "sm", position: "right" }, onClick: () => p(!0), children: a }),
    /* @__PURE__ */ r.jsx(tr, { ...l, isOpen: c, onClose: () => p(!1), children: e })
  ] });
};
export {
  tr as D,
  $r as a
};
